@if (
  {
    id: id$ | async,
    skillOptions: skillOptions$ | async,
    skillsMap: skillsMap$ | async,
    avatarUrl: avatarUrl$ | async,
    avatarImgLoading: avatarImgLoading$ | async,
    uploadProgress: uploadProgress$ | async,
    isActiveUserAdmin: isActiveUserAdmin$ | async,
    user: user$ | async,
    activeUser: activeUser$ | async,
    roleOptions: roleOptions$ | async,
    teamOptions: teamOptions$ | async,
    lensOptions: lensOptions$ | async,
    timezoneOptions: timezoneOptions$ | async
  };
  as state
) {
  <!-- <div class="main-container"> -->
  @if (state.isActiveUserAdmin && !isUserProfileView()) {
    <list-views-detail-back (back)="onBack()" />
  }

  <div class="sub-container">
    <!-- -------------------------LEFT CONTAINER------------------------------- -->
    <div class="sub-container-left-container">
      <div class="sub-container-header">
        <span class="title">
          @if (isUserProfileView()) {
            PROFILE
          } @else {
            @if (state.id === 'new') {
              NEW USER
            } @else {
              EDIT USER
            }
          }
        </span>
        <div class="sub-container-header-right-container">
          <oph-button color="green" (buttonClick)="onSave(state.id)" [loading]="loadingSave$ | async">
            <img src="assets/img/icons/check-white.svg" />
            Save
          </oph-button>
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-title">PERSONAL DETAILS</span>
        <div class="dual-input">
          <user-detail-input
            label="FIRST NAME"
            [control]="firstNameControl"
            [showError]="firstNameControl.touched && firstNameControl.invalid"
          />
          <user-detail-input
            label="LAST NAME"
            [control]="lastNameControl"
            [showError]="lastNameControl.touched && lastNameControl.invalid"
          />
        </div>
        <div class="dual-input">
          <user-detail-input
            label="USERNAME"
            [control]="usernameControl"
            class="w-50p"
            [showError]="usernameControl.touched && usernameControl.invalid"
          />
          <user-detail-input
            label="EMAIL"
            [control]="emailControl"
            class="w-50p"
            [showError]="emailControl.touched && emailControl.invalid"
          />
        </div>
        <div class="dual-input">
          @if (state.timezoneOptions?.length) {
            <user-detail-input
              type="menu"
              label="TIMEZONE"
              [options]="state.timezoneOptions"
              [menuButtonDisplay]="getTimezoneDisplayText()"
              (menuChange)="onTimezoneChange($event)"
            />
          } @else {
            <span class="form-item-title form-item-title--center">Loading timezones...</span>
          }
          <!-- Empty div to maintain layout -->
          <div class="w-50p empty"></div>
        </div>
      </div>
      <div class="form-item">
        <span class="form-item-title">CREDENTIALS</span>
        <div class="dual-input">
          <user-detail-input
            [label]="state.id === 'new' ? 'PASSWORD' : 'CHANGE PASSWORD'"
            [control]="passwordControl"
            inputType="password"
            [showError]="passwordControl.touched && passwordControl.invalid"
          />
          <user-detail-input
            label="CONFIRM PASSWORD"
            [control]="confirmPasswordControl"
            inputType="password"
            [showError]="confirmPasswordControl.touched && form.errors?.passwordMismatch"
          />
          @if (confirmPasswordControl.touched && form.errors?.passwordMismatch) {
            <oph-error class="password-error"> Passwords must match. </oph-error>
          }
        </div>
      </div>

      <div class="form-item" [class.disabled]="state.isActiveUserAdmin === false">
        <span class="form-item-title">USER ACCESS</span>
        <div class="triple-input">
          @if (state.roleOptions?.length) {
            <user-detail-input
              type="menu"
              label="ROLE"
              [addNoneOption]="false"
              [options]="state?.roleOptions"
              [class.disabled]="
                state.user?._id === state.activeUser?._id &&
                state.user?.roles[0]?.displayName?.toLowerCase() === 'admin'
              "
              [showError]="rolesControl.touched && rolesControl.invalid"
              [menuButtonDisplay]="rolesControl?.value?.[0]?.displayName || 'Add Role'"
              (menuChange)="onRoleChange($event)"
            />
          } @else {
            <span class="form-item-title form-item-title--center">No Roles available</span>
          }
          @if (state.teamOptions?.length) {
            <user-detail-input
              type="menu"
              label="TEAM"
              [addNoneOption]="true"
              [options]="state.teamOptions"
              [menuButtonDisplay]="teamsControl?.value?.[0]?.name || 'Assign Team'"
              [class.disabled]="isUserProfileView()"
              (menuChange)="onTeamChange($event)"
            />
          } @else {
            <span class="form-item-title form-item-title--center">No Teams available</span>
          }
          @if (state.lensOptions?.length) {
            <user-detail-input
              type="menu"
              label="LENS"
              [addNoneOption]="true"
              [options]="state.lensOptions"
              [menuButtonDisplay]="lensControl?.value?.title || 'Add Lens'"
              (menuChange)="onLensChange($event)"
              [class.disabled]="isUserProfileView()"
            />
          } @else {
            <span class="form-item-title form-item-title--center">No Lens available</span>
          }
        </div>
      </div>
      <div class="form-item" [class.disabled]="state.isActiveUserAdmin === false">
        @if (state.skillOptions?.length) {
          <span class="form-item-title">SKILLS</span>
          <div class="dual-input">
            <user-detail-input
              type="menu"
              label="ADD SKILL"
              [options]="state.skillOptions"
              [lightText]="true"
              [class.disabled]="isUserProfileView()"
              [menuButtonDisplay]="state.skillOptions[0]?.display || 'No Skills'"
              (menuChange)="onAddSkill($event)"
            />
            <!-- this is to keep the username input the same width as the first name input -->
            <div class="w-50p empty"></div>
          </div>
          <div class="chip-container">
            @for (skillId of skillsControl?.value; track skillId) {
              <div class="chip">
                {{ state.skillsMap[skillId]?.name || 'No name' }}
                <button class="chip-x-button" [class.disabled]="isUserProfileView()" (click)="onRemoveSkill(skillId)">
                  <img src="assets/img/icons/x-red-filled.svg" />
                </button>
              </div>
            }
            @if (!skillsControl.value?.length) {
              <span class="form-item-title">No Skills selected</span>
            }
          </div>
        } @else {
          <span class="form-item-title form-item-title--center">No Skills available</span>
        }
      </div>
    </div>
    <!-- -------------------------RIGHT CONTAINER------------------------------- -->
    <div class="sub-container-right-container">
      <div class="sub-container-right-header">
        @if (state.avatarUrl) {
          <button class="avatar-button" [matMenuTriggerFor]="avatarMenu">
            <img [src]="avatarUrlControl.value" />
          </button>
          <mat-menu #avatarMenu="matMenu" class="list-view-menu">
            <button
              class="menu-item delete"
              (click)="onDeleteAvatarImg()"
              (mouseenter)="deleteHovered = true"
              (mouseleave)="deleteHovered = false"
            >
              <oph-icon [name]="deleteHovered ? 'delete-white' : 'delete-brown'" [size]="20"></oph-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        } @else {
          @if (state.avatarImgLoading) {
            <button class="avatar-button avatar-loading-button" disabled>
              <img [src]="tempImageUrl" class="temp-img" />
              @if (state.uploadProgress < 100) {
                <mat-spinner
                  class="avatar-spinner"
                  mode="determinate"
                  [value]="state.uploadProgress"
                  [diameter]="40"
                ></mat-spinner>
              }
              @if (state.uploadProgress === 100) {
                <mat-spinner class="avatar-spinner" mode="indeterminate" [diameter]="40"></mat-spinner>
              }
            </button>
          } @else {
            <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
            <button class="avatar-button" (click)="fileUpload.click()">
              <img src="assets/img/avatar-cam.png" />
            </button>
          }
        }
        <div class="sub-container-right-header-text-container">
          <span class="name">{{ firstNameControl.value }} {{ lastNameControl.value }}</span>
          <span class="username">{{ usernameControl.value }}</span>
        </div>
      </div>
      <div class="right-container-item">
        <span class="label">ROLE</span>
        <div class="inner-container">
          <div class="img-container">
            <img src="assets/img/icons/tag-brown.svg" />
          </div>
          <span class="item-text">{{ rolesControl?.value?.[0]?.displayName || 'No Role assigned' }}</span>
        </div>
      </div>
      <div class="right-container-item">
        <span class="label">TEAM</span>
        <div class="inner-container">
          <div class="img-container">
            <img src="assets/img/icons/teams-brown.svg" />
          </div>
          <span class="item-text">{{ teamsControl?.value?.[0]?.name || 'No Team assigned' }}</span>
        </div>
      </div>
      @if (state.user && state.activeUser?._id !== state.user._id && state.id !== 'new') {
        <div class="send-email-container">
          <oph-button
            [style]="{width: '180px'}"
            color="green"
            (buttonClick)="onSendUserEmail()"
            [loading]="sendEmailLoading$ | async"
            >{{ state.user?.userRequestSent ? 'Resend Invite Email' : 'Send Invite Email' }}</oph-button
          >
        </div>
      }
    </div>
  </div>
  <!-- </div> -->
}
